import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0e60dc30"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "container-fluild"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "row long-row"
  })], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_router_view)], 64);
}